(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rt-connect-system"] && !Shopify.designMode) return;
  try {
    const pixelId = '652282653911679';
const lifetime = 30 * 60 * 1000;

function trackServiceEnquiries(root, {signal} = {}) {
  const preview = root.dataset.servicesMode !== 'live';
  const key = `retech.meta.services-enquiry.v1.${preview ? 'preview' : 'live'}`;
  const result = {dataset: {success: String(!!root.querySelector('[data-rc-success]')), error: String(!!root.querySelector('[data-rc-server-error]'))}};
  let loading = false;
  const status = value => { root.dataset.metaServicesTracking = value; };
  const read = () => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; } };
  const write = value => { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { status('storage-unavailable'); return false; } };
  const clear = () => { try { sessionStorage.removeItem(key); } catch {} };
  const allowed = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true
    && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function pending() {
    const attempt = read();
    if (!attempt || attempt.path !== location.pathname || !/^rts-meta-[a-zA-Z0-9-]+$/.test(attempt.id || '') || !Number.isFinite(attempt.at)) return null;
    if (attempt.at > Date.now() || Date.now() - attempt.at > lifetime) { clear(); status('expired'); return null; }
    return attempt;
  }
  function dispatch() {
    if (signal?.aborted || !allowed() || result?.dataset.success !== 'true' || result?.dataset.error === 'true') return;
    const attempt = pending();
    if (!attempt || attempt.sent) return;
    const fbq = window.fbq;
    if (typeof fbq !== 'function' || typeof fbq.callMethod !== 'function') { status('pixel-unavailable'); return; }
    try {
    const state = typeof fbq.getState === 'function' ? fbq.getState() : null;
    const initialized = state?.pixels?.some(pixel => String(pixel.id) === pixelId);
    if (!initialized && !window.__rtMetaEnquiryPixelInitialized) {
      fbq('init', pixelId);
      window.__rtMetaEnquiryPixelInitialized = true;
    }
    if (!write({...attempt, sent: true})) return;
      fbq('trackSingle', pixelId, 'Lead', {content_name: 'Service enquiry', lead_source: 'services_form', service_id: attempt.service}, {eventID: attempt.id});
      status('dispatched');
    } catch {
      write({...attempt, sent: false}); status('dispatch-failed');
    }
  }
  function confirm() {
    if (signal?.aborted) return;
    if (result?.dataset.error === 'true') { clear(); status('form-error'); return; }
    if (result?.dataset.success !== 'true') return;
    const attempt = pending();
    if (!attempt) return;
    if (attempt.sent) { status('already-recorded'); return; }
    if (!allowed()) { status('waiting-for-consent'); return; }
    if (preview) {
      if (write({...attempt, sent: true})) status('preview-success');
      return;
    }
    if (typeof window.fbq?.callMethod === 'function') { dispatch(); return; }
    if (loading) return;
    loading = true;
    if (!window.fbq) {
      const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
      fbq.queue = []; fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0';
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
    }
    let script = document.querySelector('script[src*="connect.facebook.net"][src*="fbevents.js"]');
    const fresh = !script;
    if (fresh) { script = document.createElement('script'); script.async = true; script.src = 'https://connect.facebook.net/en_US/fbevents.js'; }
    script.addEventListener('load', () => { loading = false; dispatch(); }, {once: true, signal});
    script.addEventListener('error', () => { loading = false; status('pixel-load-failed'); }, {once: true, signal});
    status('loading-pixel');
    if (fresh) document.head.append(script);
  }
  status(preview ? 'preview-ready' : 'ready');
  document.addEventListener('visitorConsentCollected', confirm, {signal});
  window.addEventListener('pageshow', confirm, {signal});
  if (window.Shopify?.customerPrivacy) confirm();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], error => {
    if (!signal?.aborted) error ? status('privacy-unavailable') : confirm();
  });
  return {
    begin(service) {
      if (!['general','diagnostics','assembly','thermal','wordpress','office','marketing'].includes(service)) return;
      if (signal?.aborted) return;
      const id = window.crypto?.randomUUID?.();
      if (!id) { status('identifier-unavailable'); return; }
      if (write({id: `rts-meta-${id}`, at: Date.now(), path: location.pathname, service, sent: false})) status('awaiting-confirmation');
    },
    cancel() { clear(); status('cancelled'); }
  };
}

if (!customElements.get('rt-connect')) {
 class ReTechConnect extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   this.abort = new AbortController();
   const signal = this.abort.signal;
   const root = this;
   const q = selector => root.querySelector(selector);
   const form = q('form');
   if (!form) return;
   const labels = JSON.parse(q('[data-rc-labels]').textContent);
   const kind = root.dataset.kind;
   const metaService = kind === 'services' ? trackServiceEnquiries(root, {signal}) : null;
   const topic = q('[data-rc-topic]');
   const submit = q('[data-rc-submit]');
   const fields = Array.from(form.querySelectorAll('input:not([type="hidden"]),textarea'));
   const touched = new Set();
   let phase = 'idle', timer, attempt = 0, nativeStarted = false, dirty = false;
   const listen = (target, event, fn, options = {}) => target?.addEventListener(event, fn, {...options, signal});
   const announce = text => { if(q('[data-rc-announcement]')) q('[data-rc-announcement]').textContent=text; };
   const focus = element => {
    if (!element) return;
    element.focus({preventScroll:true});
    const header = document.querySelector('.rt2-header');
    const offset = Math.max(74,header?.getBoundingClientRect().height || 0) + 24;
    window.scrollTo({top:Math.max(0,element.getBoundingClientRect().top+scrollY-offset),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   };
   const lock = busy => {
    form.setAttribute('aria-busy',String(busy));
    q('[data-rc-fields]')?.toggleAttribute('inert',busy);
    if(submit){submit.disabled=busy||phase==='uncertain';submit.querySelector('span').textContent=busy?labels.sending:submit.dataset.label;}
   };
   const status = (key, nextPhase) => {
    clearTimeout(timer);phase=nextPhase;lock(false);
    const box=q('[data-rc-status]');if(!box)return;
    q('[data-rc-status-text]').textContent=labels[key];box.hidden=false;
    q('[data-rc-retry]').hidden=phase!=='uncertain';q('[data-rc-retry-note]').hidden=phase!=='uncertain';focus(box);
   };
   const error = field => {
    if(field.disabled) return '';
    const v=field.value.trim();
    if(field.type==='checkbox')return field.required&&!field.checked?labels.consent_error:'';
    if(field.required&&!v)return labels.required;
    if(v&&field.type==='email'&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v))return labels.email_error;
    if(v&&field.type==='tel'&&!window.ReTechPhone.isValid(v))return labels.phone_error;
    return '';
   };
   const showError = field => {
    const message=error(field),node=q('#'+CSS.escape(field.id+'-error'));
    if(node){node.hidden=!message;node.textContent=message;}
    if(message)field.setAttribute('aria-invalid','true');else field.removeAttribute('aria-invalid');
    field.setCustomValidity(message);return message;
   };
   const validate = () => {
    let first;
    fields.forEach(field=>{touched.add(field);if(showError(field)&&!first)first=field;});
    if(first){announce(labels.invalid);focus(first);return false;}return true;
   };
   const syncTopic = () => {
    if(!topic)return;
    q('[data-rc-help]').textContent=topic.selectedOptions[0]?.dataset.help||'';
    const selected=q('[data-rc-current]');if(selected)selected.textContent=topic.selectedOptions[0]?.textContent||'';
    ['product','order'].forEach(key=>{const box=q('[data-rc-'+key+']');if(box){box.hidden=topic.value!==key;box.querySelector('input').disabled=box.hidden;}});
    const warranty=q('[data-rc-warranty]');if(warranty)warranty.hidden=topic.value!=='warranty';
   };
   if(submit)submit.dataset.label=submit.querySelector('span').textContent;
   if(q('[data-rc-success]'))focus(q('[data-rc-success]'));
   if(q('[data-rc-server-error]')){dirty=fields.some(f=>f.value.trim());focus(q('[data-rc-server-error]'));}
   if(topic){
    const params=new URLSearchParams(location.search);
    if(kind==='services'){
     const id=params.get('service');const option=Array.from(topic.options).find(o=>o.dataset.serviceId===id);if(option)topic.value=option.value;
    }else{
     const t=params.get('topic');if(Array.from(topic.options).some(o=>o.value===t))topic.value=t;
     const product=params.get('product');
     if(product){
      topic.value='product';const input=q('[data-rc-product] input');
      if(!input.value){input.value=[product,params.get('variant'),params.get('variant_id'),params.get('price')].filter(Boolean).join(' · ').slice(0,600);}
     }
    }
    syncTopic();listen(topic,'change',()=>{dirty=true;syncTopic();});
   }
   listen(root,'click',event=>{
    const choice=event.target.closest('[data-rc-service]');
    if(!choice)return;
    event.preventDefault();if(phase==='pending'||phase==='verification'||!topic)return;
    const option=Array.from(topic.options).find(o=>o.dataset.serviceId===choice.dataset.rcService);
    if(option){topic.value=option.value;syncTopic();focus(q('[data-rc-form-heading]'));}
   });
   fields.forEach(field=>{
    listen(field,'input',()=>{dirty=true;if(touched.has(field))showError(field);});
    listen(field,'change',()=>{dirty=true;if(touched.has(field))showError(field);});
    listen(field,'blur',()=>{if(field.value.trim()||touched.has(field)){touched.add(field);showError(field);}});
   });
   form.noValidate=true;
   listen(form,'submit',event=>{
    event.preventDefault();
    event.stopImmediatePropagation();
    if(['pending','verification','uncertain'].includes(phase))return;
    if(!validate())return;
    if(navigator.onLine===false){status('offline','idle');return;}
    q('[data-rc-status]').hidden=true;q('[data-rc-server-error]')?.setAttribute('hidden','');
    nativeStarted=false;phase='verification';lock(true);const current=++attempt;
    const nativeSubmit = () => {
     if(current!==attempt||phase!=='verification'||nativeStarted)return;
     clearTimeout(timer);nativeStarted=true;phase='pending';lock(true);
     timer=setTimeout(()=>{if(current===attempt&&phase==='pending')status('unconfirmed','uncertain');},30000);
     try {metaService?.begin(topic?.selectedOptions[0]?.dataset.serviceId || 'general');form.submit();}
     catch (_) {metaService?.cancel();nativeStarted=false;attempt++;status('technical','idle');}
    };
    timer=setTimeout(()=>{if(current===attempt&&phase==='verification'){attempt++;status('verification','idle');}},30000);
    try {
     if(window.Shopify?.captcha&&typeof window.Shopify.captcha.protect==='function')window.Shopify.captcha.protect(form,nativeSubmit);
     else {attempt++;status('verification','idle');}
    }catch(_){attempt++;status('verification','idle');}
   },{capture:true});
   listen(q('[data-rc-retry]'),'click',()=>{attempt++;nativeStarted=false;phase='idle';q('[data-rc-status]').hidden=true;lock(false);focus(q('[data-rc-form-heading]'));});
   listen(q('[data-rc-reset]'),'click',()=>{metaService?.cancel();const url=new URL(location.href);['contact_posted','form_type'].forEach(k=>url.searchParams.delete(k));url.hash='';location.assign(url.pathname+url.search);});
   listen(window,'pagehide',()=>{clearTimeout(timer);if(phase==='verification'){attempt++;phase='idle';lock(false);}});
   listen(window,'pageshow',event=>{if(event.persisted&&nativeStarted&&!q('[data-rc-success]'))status('unconfirmed','uncertain');else if(event.persisted)syncTopic();});
   listen(document,'click',event=>{
    const anchor=event.target.closest('a[href]');
    if(!dirty||!anchor||anchor.target==='_blank'||event.defaultPrevented||event.ctrlKey||event.metaKey)return;
    const url=new URL(anchor.href,location.href);
    if(!/^https?:$/.test(url.protocol)||(url.pathname===location.pathname&&url.search===location.search))return;
    if(!window.confirm(labels.leave))event.preventDefault();
   });
   const localeForm=document.querySelector('#rt-language-form');
   listen(localeForm,'submit',event=>{if(dirty&&!window.confirm(labels.leave))event.preventDefault();});
   this.cleanup=()=>{clearTimeout(timer);attempt++;};
  }
  disconnectedCallback(){this.cleanup?.();this.abort?.abort();this.ready=false;}
 }
 customElements.define('rt-connect',ReTechConnect);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rt-mini-cart"] && !Shopify.designMode) return;
  try {
    window.rtCartChange = async function (key, quantity) {
    if (window.rtCartChangePending) return null;
    window.rtCartChangePending = true;
    document.dispatchEvent(new CustomEvent('rt:cart-busy', { detail: true }));
    var root = (window.Shopify && window.Shopify.routes.root) || '/';
    async function request(path, options) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await fetch(root + path, Object.assign({ headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, signal: controller.signal }, options));
        var data = await response.json();
        return { ok: response.ok, status: response.status, data: data };
      } finally { clearTimeout(timer); }
    }
    var cart = null, error = '';
    try {
      var result = await request('cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: quantity }) });
      if (!result.ok || !Array.isArray(result.data.items)) {
        error = result.status === 422 ? 'stock' : 'update';
      } else {
        cart = result.data;
        var item = cart.items.find(function (item) { return item.key === key; });
        if (quantity > 0 && (!item || item.quantity !== quantity)) error = 'stock';
      }
    } catch (failure) { error = 'update'; }
    try {
      if (!cart) {
        var latest = await request('cart.js');
        if (latest.ok && Array.isArray(latest.data.items)) cart = latest.data;
      }
      if (cart) document.dispatchEvent(new CustomEvent('rt:cart-updated', { detail: cart }));
      return { cart: cart, error: error };
    } catch (failure) { return { cart: null, error: error || 'update' }; }
    finally {
      window.rtCartChangePending = false;
      document.dispatchEvent(new CustomEvent('rt:cart-busy', { detail: false }));
    }
  };

  (function () {
    var dialog = document.querySelector('[data-rt-mini-cart]');
    if (!dialog || dialog.dataset.ready === 'true') return;
    dialog.dataset.ready = 'true';

    var updateError = dialog.querySelector('[data-rt-mini-cart-update-error]');
    var itemsElement = dialog.querySelector('[data-rt-mini-cart-items]');
    var emptyElement = dialog.querySelector('[data-rt-mini-cart-empty]');
    var loadingElement = dialog.querySelector('[data-rt-mini-cart-loading]');
    var footerElement = dialog.querySelector('[data-rt-mini-cart-footer]');
    var totalElement = dialog.querySelector('[data-rt-mini-cart-total]');
    var closeButtons = dialog.querySelectorAll('[data-rt-mini-cart-close]');
    var mobileMedia = window.matchMedia('(max-width: 620px)');
    var lastTrigger = null;

    function money(cents, currency) {
      return new Intl.NumberFormat(document.documentElement.lang || 'bg-BG', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format((Number(cents) || 0) / 100);
    }

    function createItem(item, currency) {
      var row = document.createElement('article');
      row.className = 'rt-mini-cart-item';

      var media = document.createElement('a');
      media.className = 'rt-mini-cart-media';
      media.href = item.url;

      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = item.product_title || '';
        image.width = 180;
        image.height = 180;
        media.appendChild(image);
      } else {
        var initial = document.createElement('span');
        initial.textContent = (item.product_title || 'R').slice(0, 1);
        media.appendChild(initial);
      }

      var info = document.createElement('div');
      info.className = 'rt-mini-cart-info';

      var title = document.createElement('a');
      title.className = 'rt-mini-cart-title';
      title.href = item.url;
      title.textContent = item.product_title || item.title || '';
      info.appendChild(title);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variant = document.createElement('span');
        variant.className = 'rt-mini-cart-variant';
        variant.textContent = item.variant_title;
        info.appendChild(variant);
      }

      var quantity = document.createElement('span');
      quantity.className = 'rt-mini-cart-quantity';
      quantity.textContent = item.quantity + ' × ' + money(item.final_price || item.price, currency);
      info.appendChild(quantity);

      var controls = document.createElement('div');
      controls.className = 'rt-mini-cart-controls';

      var decrease = document.createElement('button');
      decrease.type = 'button';
      decrease.className = 'rt-mini-cart-qty-button';
      decrease.dataset.rtCartAction = 'decrease';
      decrease.dataset.lineKey = item.key;
      decrease.dataset.quantity = item.quantity;
      decrease.disabled = item.quantity <= 1;
      decrease.setAttribute('aria-label', dialog.dataset.decreaseLabel + ': ' + (item.product_title || item.title || ''));
      decrease.textContent = '−';

      var quantityValue = document.createElement('span');
      quantityValue.className = 'rt-mini-cart-qty-value';
      quantityValue.setAttribute('aria-label', item.quantity);
      quantityValue.textContent = item.quantity;

      var increase = document.createElement('button');
      increase.type = 'button';
      increase.className = 'rt-mini-cart-qty-button';
      increase.dataset.rtCartAction = 'increase';
      increase.dataset.lineKey = item.key;
      increase.dataset.quantity = item.quantity;
      increase.setAttribute('aria-label', dialog.dataset.increaseLabel + ': ' + (item.product_title || item.title || ''));
      increase.textContent = '+';

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'rt-mini-cart-remove';
      remove.dataset.rtCartAction = 'remove';
      remove.dataset.lineKey = item.key;
      remove.dataset.quantity = item.quantity;
      remove.setAttribute('aria-label', dialog.dataset.removeLabel + ': ' + (item.product_title || item.title || ''));
      remove.innerHTML = '<span aria-hidden="true">×</span><span></span>';
      remove.lastElementChild.textContent = dialog.dataset.removeLabel;

      controls.appendChild(decrease);
      controls.appendChild(quantityValue);
      controls.appendChild(increase);
      controls.appendChild(remove);
      info.appendChild(controls);

      var line = document.createElement('strong');
      line.className = 'rt-mini-cart-line';
      line.textContent = money(item.final_line_price, currency);

      row.appendChild(media);
      row.appendChild(info);
      row.appendChild(line);
      return row;
    }

    function render(cart) {
      updateError.hidden = true;
      itemsElement.replaceChildren();
      cart.items.forEach(function (item) {
        itemsElement.appendChild(createItem(item, cart.currency));
      });

      var isEmpty = cart.item_count === 0;
      emptyElement.hidden = !isEmpty;
      footerElement.hidden = isEmpty;
      loadingElement.hidden = true;
      itemsElement.hidden = false;
      totalElement.textContent = money(cart.total_price, cart.currency);

      document.querySelectorAll('[data-rt-cart-count]').forEach(function (count) {
        count.textContent = cart.item_count;
        count.hidden = isEmpty;
      });
    }

    function renderError() {
      updateError.textContent = dialog.dataset.updateErrorLabel;
      updateError.hidden = false;
      itemsElement.hidden = false;
      loadingElement.hidden = true;
    }

    function refresh() {
      loadingElement.hidden = false;
      itemsElement.hidden = true;
      emptyElement.hidden = true;
      return fetch((window.Shopify && window.Shopify.routes.root || '/') + 'cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(render)
        .catch(renderError);
    }

    async function changeQuantity(button) {
      if (window.rtCartChangePending) return;
      var action = button.dataset.rtCartAction;
      var currentQuantity = Number(button.dataset.quantity) || 1;
      var nextQuantity = action === 'remove' ? 0 : action === 'increase' ? currentQuantity + 1 : Math.max(1, currentQuantity - 1);
      if (nextQuantity === currentQuantity) return;
      updateError.hidden = true;
      var result = await window.rtCartChange(button.dataset.lineKey, nextQuantity);
      if (result && result.error) {
        updateError.textContent = result.error === 'stock' ? dialog.dataset.stockLabel : dialog.dataset.updateErrorLabel;
        updateError.hidden = false;
      }
    }

    document.addEventListener('rt:cart-updated', function (event) { render(event.detail); });
    document.addEventListener('rt:cart-busy', function (event) {
      dialog.setAttribute('aria-busy', String(event.detail));
      dialog.querySelectorAll('[data-rt-cart-action], [name="checkout"]').forEach(function (button) {
        if (event.detail) { button.dataset.wasDisabled = String(button.disabled); button.disabled = true; }
        else if (button.dataset.wasDisabled !== undefined) { button.disabled = button.dataset.wasDisabled === 'true'; delete button.dataset.wasDisabled; }
      });
    });

    function positionBubble(trigger) {
      if (!mobileMedia.matches) return;
      var anchor = trigger || document.querySelector('[data-rt-mini-cart-trigger]');
      if (!anchor) return;
      var rect = anchor.getBoundingClientRect();
      dialog.style.setProperty('--rt-mini-cart-top', Math.round(rect.bottom + 8) + 'px');
    }

    function open(trigger) {
      lastTrigger = trigger || lastTrigger || document.querySelector('[data-rt-mini-cart-trigger]');
      positionBubble(lastTrigger);
      if (!dialog.open) {
        if (mobileMedia.matches) dialog.show();
        else dialog.showModal();
      }
      document.documentElement.classList.toggle('rt-mini-cart-open', !mobileMedia.matches);
      refresh();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    document.addEventListener('click', function (event) {
      var cartAction = event.target.closest('[data-rt-cart-action]');
      if (cartAction && dialog.contains(cartAction)) {
        event.preventDefault();
        changeQuantity(cartAction);
        return;
      }

      var trigger = event.target.closest('[data-rt-mini-cart-trigger]');
      if (trigger) {
        event.preventDefault();
        open(trigger);
        return;
      }

      if (dialog.open && mobileMedia.matches && !dialog.contains(event.target)) close();
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', close);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('rt-mini-cart-open');
    });

    window.addEventListener('resize', function () {
      if (dialog.open && mobileMedia.matches) positionBubble(lastTrigger);
    });

    window.addEventListener('retech:add_to_cart', function () {
      window.setTimeout(open, 80);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rt-shipping-calculator"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rt-delivery]').forEach(function (root) {
    var form = root.querySelector('[data-delivery-form]');
    var country = form.elements.country;
    var province = form.elements.province;
    var zip = form.elements.zip;
    var result = root.querySelector('[data-delivery-result]');
    var button = root.querySelector('[data-delivery-button]');
    var buttonLabel = button.textContent;
    var controller = null;
    var generation = 0;
    var hasResult = false;
    var base = root.dataset.root.replace(/\/?$/, '/');
    if (country.options[0] && country.options[0].value === '---') country.options[0].value = '';
    function invalidate() {
      generation += 1;
      if (controller) controller.abort();
      controller = null;
      button.disabled = false;
      button.textContent = buttonLabel;
      result.removeAttribute('aria-busy');
      if (hasResult) result.textContent = root.dataset.stale;
    }
    function updateProvinces() {
      var option = country.options[country.selectedIndex];
      var values = [];
      try { values = JSON.parse(option.dataset.provinces || '[]'); } catch (ignore) {}
      province.replaceChildren();
      values.forEach(function (value) { province.add(new Option(value[1], value[0])); });
      province.disabled = values.length === 0;
      province.required = values.length > 0;
      root.querySelector('[data-delivery-province]').hidden = !values.length;
      invalidate();
    }
    var preferred = Array.from(country.options).find(function (option) { return option.value === root.dataset.country || option.textContent === root.dataset.country; });
    if (preferred) country.value = preferred.value;
    country.addEventListener('change', updateProvinces);
    province.addEventListener('change', invalidate);
    zip.addEventListener('input', invalidate);
    window.addEventListener('pageshow', invalidate);
    document.addEventListener('cart:update', invalidate);
    window.addEventListener('retech:add_to_cart', invalidate);
    updateProvinces();
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (button.disabled || !form.reportValidity()) return;
      invalidate();
      var request = generation;
      controller = new AbortController();
      var requestController = controller;
      var signal = controller.signal;
      var timeout = setTimeout(function () { requestController.abort(); }, 15000);
      var parameters = new URLSearchParams({ 'shipping_address[country]': country.value, 'shipping_address[zip]': zip.value.trim() });
      if (!province.disabled) parameters.set('shipping_address[province]', province.value);
      button.disabled = true;
      button.textContent = root.dataset.loading;
      result.textContent = root.dataset.loading;
      result.setAttribute('aria-busy', 'true');
      hasResult = true;
      try {
        var prepared = await fetch(base + 'cart/prepare_shipping_rates.json?' + parameters, { method: 'POST', credentials: 'same-origin', signal: signal });
        if (!prepared.ok) throw new Error('rates');
        var data = null;
        for (var attempt = 0; attempt < 8; attempt += 1) {
          if (attempt) await new Promise(function (resolve) { setTimeout(resolve, 800); });
          var response = await fetch(base + 'cart/async_shipping_rates.json?' + parameters, { credentials: 'same-origin', cache: 'no-store', signal: signal });
          if (!response.ok) throw new Error('rates');
          data = await response.json();
          if (data !== null) break;
        }
        if (request !== generation) return;
        if (!data || !Array.isArray(data.shipping_rates)) throw new Error('rates');
        result.replaceChildren();
        if (!data.shipping_rates.length) result.textContent = root.dataset.empty;
        else {
          var list = document.createElement('ul');
          data.shipping_rates.forEach(function (rate) {
            var price = Number(rate.price);
            if (!Number.isFinite(price)) throw new Error('price');
            var item = document.createElement('li');
            item.textContent = (rate.presentment_name || rate.name) + ' — ' + new Intl.NumberFormat(document.documentElement.lang || 'bg', { style: 'currency', currency: rate.currency || root.dataset.currency }).format(price);
            list.appendChild(item);
          });
          result.appendChild(list);
        }
      } catch (error) {
        if (request === generation) result.textContent = root.dataset.error;
      } finally {
        clearTimeout(timeout);
        if (request === generation) {
          controller = null;
          button.disabled = false;
          button.textContent = buttonLabel;
          result.removeAttribute('aria-busy');
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
